// todo - sync for all project
export const LANGUAGES = ['en', 'es', 'ru', 'tr', 'pt', 'zh', 'ro', 'bg', 'el'] as const;
export type Language = typeof LANGUAGES[number];
export type TranslationDictionary = Record<string, string>;
export type LocaleValue = Record<string, string | number>
export type LocaleResources = Record<string, LocaleValue>;
type NamespaceResource = {
    [L in Language]: TranslationDictionary;
};

export type LocaleResourcesOrder = Record<string, (string|number)[]>;

export type LocaleResult<T extends LocaleResources, O extends LocaleResourcesOrder | undefined> = {
    [K in keyof T]: O extends Record<K, Array<string | number>>
      ? Map<string|number, string>
      : Record<string|number, string>;
};

export type Namespace =
    | 'common'
    | 'brand'
    | 'validate'
    | 'mapping'
    | 'title'
    | 'confirm'
    | 'notification'
    | 'bonus'
    | 'cms'
    | 'player'
    | 'payment'
    | 'bet'
    | 'communication'
    | 'tool'
    | 'auditLog'
    | 'riskManagement'
    | 'reporting'
    | 'partner'
    | 'userManagement'
    | 'dashboard'
    | 'devTool'
    | 'gamification'
    | 'regulatory'
    | 'system';

export type Resources = Record<Namespace, NamespaceResource>;

export type I18nResources = {
    [L in Language]: {
        [N in Namespace]: TranslationDictionary;
    };
};
